`<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('donation.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'support-donation' }">{{ $t('donation.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>關於本會</h3>
        <p>
          本會為非營利機構，完全依靠十方大德的捐贈賴以維持會務。民國七十三年成立以來，秉持「有多少錢做多少事」及「專款專用」的原則與理念，開設各種佛學課程，製作各種佛學出版品、DVD/VCD/MP3等光碟，及網路弘化工作，皆完全免費與大眾結緣。亦需要大家多多護持，讓佛陀教育能永續弘揚，正法能久住世間。
        </p>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>捐款項目</h3>
        <p>所謂布施者，必獲其利益，若為樂故施，後必得安樂。</p>
        <p>
          對於您的布施，本會必定會審慎、善加利用，使您得到最大的功德迴向：祈願布施者，於現世中能得到最大的安樂；乃至盡未來際，能永久解脫生死輪迴之苦，共證無上菩提佛果。
        </p>
        <p>本會功德金之使用，在董事會、各級幹部之監管下，以公開、透明化之原則辦理，保證財務系統健全，並每月定期公告大眾周知。詳情請參考本會「功德徵信」內容。敬請放心！並感謝您對於本會之信任！</p>
        <p>本會絕無託人在外義賣募款之情事：本會公開接受捐款之帳號僅止於此網頁頁面下方所公告者，並無再有其他公開管道或方式，敬請明察，慎防詐騙。</p>
        <b-table-simple caption-top hover fixed>
          <caption>●捐款時請註明捐款用途，項目如下：</caption>
          <b-tbody>
            <b-tr>
              <b-td>1. 會務支出 (護持道場)</b-td>
              <b-td>本會之維持費用</b-td>
            </b-tr>
            <b-tr>
              <b-td>2. 印 (購) 經書法寶及運費</b-td>
              <b-td>依計劃及專業指定印購經書及流通法寶</b-td>
            </b-tr>
            <b-tr>
              <b-td>3. 資訊設備影音製播</b-td>
              <b-td>本會網站、影音製播、電腦軟硬體設備及相關費用</b-td>
            </b-tr>
            <b-tr>
              <b-td>4. 護生環保宣導</b-td>
              <b-td>每月不定金額隨緣放生及護生相關工作</b-td>
            </b-tr>
            <b-tr>
              <b-td>5. 社教公益 (慈善救濟)</b-td>
              <b-td>用於社教、慈善、助學、公益…等工作</b-td>
            </b-tr>
            <b-tr>
              <b-td>6. 敬師金</b-td>
              <b-td>本會課程活動之講師、助教、譯師相關費用及供僧款項等</b-td>
            </b-tr>
            <b-tr>
              <b-td>7. 華藏教學園區</b-td>
              <b-td>園區之維持費用及活動支出</b-td>
            </b-tr>
            <b-tr>
              <b-td>8. 指定專款-弘化基金</b-td>
              <b-td>係指定用途之捐款，依指定項目使用</b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-td colspan="2" variant="transparent" class="text-right">
                （本會所有款項均公開、定期徵信。敬請明察。）
              </b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>{{ $t('donation.heading.credit-card') }}</h3>
        <p v-if="$i18n.locale === 'tw'">
          為保障您的資料安全，回傳時：<br>
          請務必使用傳真／郵寄方式，切勿使用E-mail寄回！<br>
          ‧台灣地區：請使用以下其中一種授權書，以傳真／郵寄方式回傳。<br>
　　      1. <a href="https://www2.budaedu.org/official-website-data/support-donation/domestic_credit_card_donate.pdf" target="_blank">台灣地區信用卡授權書 (PDF 格式)</a><br>
　　      2. <a href="https://www2.budaedu.org/official-website-data/support-donation/domestic_credit_card_donate.jpg" target="_blank">台灣地區信用卡授權書 (圖片檔)</a><br>
          3. 大陸及海外地區：請使用<a href="https://www2.budaedu.org/official-website-data/support-donation/overseas_credit_card_donate.htm" target="_blank">海外地區信用卡授權書</a>，以傳真／郵寄回傳。
        </p>
        <p v-if="$i18n.locale === 'en'">
          If you wish to make an donation by money or credit card via ordinary mail or fax, then please use our manual <a href="https://www2.budaedu.org/official-website-data/support-donation/overseas_credit_card_donate.htm" target="_blank">Donation form</a>.
        </p>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>郵政劃撥</h3>
        <p>
          劃撥帳號：07694979<br>
          戶名：財團法人佛陀教育基金會
        </p>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>{{ $t('donation.heading.wire-transfer.domestic') }}</h3>
        <p>
          銀行名稱：台灣銀行／城中分行<br>
          銀行代碼：004<br>
          帳號：045004597503
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>{{ $t('donation.heading.wire-transfer.international') }}</h3>
        <b-table-simple hover fixed v-if="$i18n.locale === 'tw'">
          <b-tbody>
            <b-tr>
              <b-td>銀行名稱</b-td>
              <b-td>台灣銀行城中分行</b-td>
            </b-tr>
            <b-tr>
              <b-td>銀行地址</b-td>
              <b-td>台北市青島東路47號</b-td>
            </b-tr>
            <b-tr>
              <b-td>Swift Code</b-td>
              <b-td>BKTWTWTP045</b-td>
            </b-tr>
            <b-tr>
              <b-td>戶名</b-td>
              <b-td>財團法人佛陀教育基金會</b-td>
            </b-tr>
            <b-tr>
              <b-td>帳號</b-td>
              <b-td>045004597503</b-td>
            </b-tr>
            <b-tr>
              <b-td>本會地址</b-td>
              <b-td>台北市杭州南路一段55號11樓</b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-td colspan="2">
                備註：<br>
                1. 戶名敬請務必填寫完整，否則會被退匯。<br>
                2. 詳細匯款資訊，請以Email通知本會，惠寄至：<a href="mailto:scyang@budaedu.org">scyang@budaedu.org</a>，以方便核對，謝謝！
              </b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
        <b-table-simple hover fixed>
          <b-tbody>
            <b-tr>
              <b-td>Bank Name</b-td>
              <b-td>Chen Chong Branch, Bank of Taiwan</b-td>
            </b-tr>
            <b-tr>
              <b-td>Bank Address</b-td>
              <b-td>No.47, Ching Tau East Road, Taipei city, Taiwan, R.O.C.(Post Code: 100)</b-td>
            </b-tr>
            <b-tr>
              <b-td>Swift Code</b-td>
              <b-td>BKTWTWTP045</b-td>
            </b-tr>
            <b-tr>
              <b-td>Account Name</b-td>
              <b-td>The Corporate Body of The Buddha Educational Foundation</b-td>
            </b-tr>
            <b-tr>
              <b-td>Account No.</b-td>
              <b-td>045004597503</b-td>
            </b-tr>
            <b-tr>
              <b-td>Our Address</b-td>
              <b-td>11F, 55, Sec. 1, Hang-Chow S. Road, Taipei city, Taiwan, R.O.C.(Post Code: 100)</b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-td colspan="2">
                Remarks：<br>
                1. Please fill in the Account Name (The Corporate Body of The Buddha Educational Foundation) entirely and completely, otherwise the remittance will be canceled and refunded.<br>
                2. In order to confirm and check easily, please kindly inform us the detail remitting information by sending Email to：<a href="mailto:scyang@budaedu.org">scyang@budaedu.org</a>
              </b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
        <b-table-simple hover fixed>
          <b-tbody>
            <b-tr>
              <b-td>
                Purpose for Donation：<br>
                1. Supporting Foundation<br>
                2. Printing & Delivery<br>
                3. Video & Audio<br>
                4. Relieving Life<br>
                5. Public Welfare & Charity<br>
                6. Offering for Teachers<br>
                7. Hwa Dzan Teaching Garden<br>
                8. Special Purpose
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <!-- <b-table-simple caption-top hover fixed>
          <b-thead head-variant="dark">
            <b-tr>
              <b-th colspan="2">中文名稱</b-th>
              <b-th colspan="2">English Name</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>銀行名稱</b-td>
              <b-td>台灣銀行城中分行</b-td>
              <b-td>Bank Name</b-td>
              <b-td>Chen Chong Branch, Bank of Taiwan</b-td>
            </b-tr>
            <b-tr>
              <b-td>銀行地址</b-td>
              <b-td>台北市青島東路47號</b-td>
              <b-td>Bank Address</b-td>
              <b-td>No.47, Ching Tau East Road, Taipei city, Taiwan, R.O.C.(Post Code: 100)</b-td>
            </b-tr>
            <b-tr>
              <b-td>Swift Code</b-td>
              <b-td>BKTWTWTP045</b-td>
              <b-td>Swift Code</b-td>
              <b-td>BKTWTWTP045</b-td>
            </b-tr>
            <b-tr>
              <b-td>戶名</b-td>
              <b-td>財團法人佛陀教育基金會</b-td>
              <b-td>Account Name</b-td>
              <b-td>The Corporate Body of The Buddha Educational Foundation</b-td>
            </b-tr>
            <b-tr>
              <b-td>帳號</b-td>
              <b-td>045004597503</b-td>
              <b-td>Account No.</b-td>
              <b-td>045004597503</b-td>
            </b-tr>
            <b-tr>
              <b-td>本會地址</b-td>
              <b-td>台北市杭州南路一段55號11樓</b-td>
              <b-td>Our Address</b-td>
              <b-td>11F, 55, Sec. 1, Hang-Chow S. Road, Taipei city, Taiwan, R.O.C.(Post Code: 100)</b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-td colspan="4" variant="transparent" class="text-left">
                備註：<br>
                1. 戶名敬請務必 填寫完整，否則會被退匯。<br>
                2. 詳細匯款資訊，請以Email通知本會，惠寄至：scyang@budaedu.org，以方便核對，謝謝！
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="4" variant="transparent" class="text-left">
                Purpose for Donation：<br>
                1. Supporting Foundation<br>
                2. Printing & Delivery<br>
                3. Video & Audio<br>
                4. Relieving Life<br>
                5. Public Welfare & Charity<br>
                6. Offering for Teachers<br>
                7. Hwa Dzan Teaching Garden<br>
                8. Special Purpose
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="4" variant="transparent" class="text-left">
                Remarks：<br>
                1. Please fill in the Account Name (The Corporate Body of The Buddha Educational Foundation) entirely and completely, otherwise the remittance will be canceled and refunded.<br>
                2. In order to confirm and check easily, please kindly inform us the detail remitting information by sending Email to：scyang@budaedu.org
              </b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple> -->
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>台灣行動支付</h3>
        <p>台灣行動支付 QR Code</p>
        <b-img src="https://www2.budaedu.org/official-website-data/support-donation/taiwan_pay_qr_code.jpg" fluid></b-img>
        <p>
          基金會自即日起可使用台灣行動支付捐款<br>
          台灣Pay是由政府協同金融機構所推動「電子支付」及「行動支付」應用，功能非常多元。<br>
          使用台灣Pay捐款程序如下：<br>
          1. 下載台灣Pay「台灣行動支付App」。<br>
          2. 掃描帳號QR Code。<br>
          3. 輸入金額。<br>
          4. 選擇「台灣Pay」金融卡卡片，輸入密碼。<br>
          5. 請E-mail至：scyang@budaedu.org告知捐款內容，包含：年/月/日/時間/金額/用途...等等。<br>
          6. 交易完成。
        </p>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>財政部《愛心碼》使用說明</h3>
        <p>本會的「愛心碼條碼」</p>
        <b-img src="https://www2.budaedu.org/official-website-data/support-donation/lovecode_barcode.jpg" fluid></b-img>
        <p>
          本會的愛心碼為「5511」，單位簡稱為「佛陀教育」。<br>
          「愛心碼捐贈電子發票」：在消費時，可以口述「愛心碼5511」或持「愛心碼的條碼」，即可將電子發票直接捐贈給本會。<br>
          歡迎大眾一同響應，讓社會大眾的愛心，更有效率地流向各個公益團體，將無形的電子發票化為支持公益團體的美意，同時減少紙本發票的開立，為地球的環保盡一份心力！
        </p>
      </div>
    </div>
    <div class="row" v-if="$i18n.locale === 'tw'">
      <div class="col">
        <h3>財務公開</h3>
        <p>
          本會功德金之使用，在董事會、各級幹部之監管下，以公開、透明化之原則辦理，保證財務系統健全，並每月定期公告大眾周知。<br>
          關於「資金收支表」「功德芳名」請參考＞＞<router-link :to="{ name: 'financial-disclosures' }">功德徵信</router-link><br>
          敬請放心！並感謝您對於本會之信任！
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ImagePlugin)
Vue.use(TablePlugin)

export default {
  i18n,
  name: 'support-donation',
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('donation.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>